const createFilterFormattedResponse = (rawData: any) => {
  const {
    name,
    filterParams = [],
    message,
    sharedUrl,
    id,
  } = rawData?.data?.data || []

  return {
    name,
    filterParams,
    message,
    sharedUrl,
    id,
  }
}

const getFilterFormattedResponse = (rawData: any) => {
  const result = rawData?.data?.data || []

  return result?.map(({ id, name }: { id: number; name: string }) => ({
    id: +id,
    filterName: name,
  }))
}

const showFilterFormattedResponse = (rawData: any) => {
  const { id, name, filterParams, sharedUrl } = rawData?.data?.data || []

  return {
    id: +id,
    filterName: name,
    filterParams,
    sharedUrl,
  }
}

const filterSetFormattedResponses = {
  createFilterFormattedResponse,
  getFilterFormattedResponse,
  showFilterFormattedResponse,
}

export default filterSetFormattedResponses
